(function () {
  "use strict";

  /* ============================================================
     KIT EXPERIMENTAÇÃO — produto EXCLUSIVO no carrinho (03/Ago/2026)

     Regra de negócio:
       O Kit Experimentação (3 mini potes grátis + frete fixo R$29,90 de
       perfil dedicado) não pode dividir carrinho com nenhum outro produto.
       Se QUALQUER produto entra com o Kit presente → o Kit sai e o cupom
       KITEXPERIMENTACAOGRATIS é removido junto.

     Por que o cupom também sai:
       O Kit custa R$59,90 no catálogo; ele só fica grátis por causa do
       cupom que a LP injeta no permalink. O cupom vive no carrinho de forma
       INDEPENDENTE dos itens — removendo só o produto, o desconto continuaria
       aplicado sobre o que sobrou (furo observado em produção: -R$247,27
       abatidos num carrinho com creatina paga).

     O lado LP→carrinho já funciona sem código:
       Os CTAs da /pages/lp-kit-experimentacao usam CART PERMALINK
       (/cart/51373867368757:1?discount=...), e permalink RECONSTRÓI o
       carrinho do zero — já zera os outros produtos sozinho. Este guard
       cobre só o caminho inverso (adicionar por cima do Kit).

     Comportamentos não-óbvios:
       - Intercepta window.fetch e XMLHttpRequest: cobre TODOS os caminhos de
         adição de uma vez (PDP, order bump do drawer, pop-ups ups-*.js, Vex,
         apps de terceiros) em vez de tentar mapear cada botão.
       - EXCEÇÃO Sérum La Roche: é o Vex adicionando automaticamente ao bater
         R$384,90, não uma escolha da cliente. Se disparasse a regra, o Kit
         sumiria por ação do sistema — comportamento imprevisível pra cliente.
       - O Kit sendo re-adicionado (permalink da LP de novo) NÃO se auto-remove:
         a regra só age quando um item DIFERENTE do Kit entra.
       - Cupom digitado à mão sem o Kit no carrinho também é recusado, senão
         sobraria um caminho aberto pra usar o desconto fora do contexto.
       - O tema redesenha a gaveta do carrinho a cada mudança (reinjeta o
         conteúdo em #halo-cart-sidebar .previewCart-wrapper) → o toast é
         re-injetado via MutationObserver.

     PORTE PARA O TEMA NOVO (21/Ago/2026): o tema antigo usava o carrinho do app
     Kaching, que não existe aqui. A REGRA (ler /cart.js, remover com
     /cart/change.js, interceptar fetch/XHR) não mudou uma linha. Mudou o que
     conversa com o tema:
       • toast: encaixa em #halo-cart-sidebar .halo-sidebar-wrapper (vem do
         Liquid, sempre no DOM) em vez de .kaching-cart__contents;
       • redesenho: window.updateCart() (theme.js:240). Diferente dos guards de
         mini pote e garrafa, aqui ABRIR a gaveta é desejado: a remoção é reação
         direta a um clique da cliente, e ela precisa ver o porquê;
       • cupom: o campo do Kaching virou o <cart-discount-component>
         (cart-tools.js), que aceita MÚLTIPLOS cupons ao mesmo tempo. Isso muda
         duas coisas — ver os blocos CUPOM abaixo.

     Rollback: remover a linha do theme.liquid.
     ============================================================ */

  try {
    if (window.__GD_KIT_GUARD_LOADED) return;
    window.__GD_KIT_GUARD_LOADED = true;

    /* ======================== CONFIG ======================== */

    var KIT_VARIANT_ID = 51373867368757; // Kit Experimentação (R$59,90 no catálogo)
    var KIT_PRODUCT_ID = "10245392400693"; // combo-guday-kit-experimentacao
    var SERUM_VARIANT_ID = 53242273235253; // brinde La Roche (Vex) — não dispara a regra
    var KIT_COUPON_RE = /^KITEXPERIMENTACAO/i;

    var TOAST_ID = "gd-kit-toast";
    var STYLE_ID = "gd-kit-guard-css";

    var MSG_REMOVED =
      "<b>Kit Experimentação removido.</b> Ele é exclusivo e não pode ser combinado com outros produtos.";
    var MSG_COUPON =
      "<b>Cupom não aplicado.</b> Ele vale apenas para o Kit Experimentação sozinho no carrinho.";

    var ROOT =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";

    /* ======================== CSS ======================== */

    function injectCSS() {
      if (document.getElementById(STYLE_ID)) return;
      var css =
        "#" +
        TOAST_ID +
        "{display:flex;align-items:flex-start;gap:8px;" +
        "margin:0 16px 10px;padding:10px 12px;background:#FFF6E5;border:1px solid #F2D9A8;" +
        "border-left:3px solid #E8A33D;border-radius:8px;font-size:12.5px;color:#6B4A12;" +
        "line-height:1.45;animation:gd-kit-in .35s cubic-bezier(.22,.8,.35,1);}" +
        "@keyframes gd-kit-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}" +
        "#" +
        TOAST_ID +
        " .gd-kit-ico{flex-shrink:0;font-size:14px;line-height:1.2;}" +
        "#" +
        TOAST_ID +
        " .gd-kit-txt{flex:1;}" +
        "#" +
        TOAST_ID +
        " .gd-kit-txt b{color:#4A330A;}" +
        "#" +
        TOAST_ID +
        " .gd-kit-x{background:none;border:0;cursor:pointer;color:#8a6a30;" +
        "font-size:15px;line-height:1;padding:0 2px;}";
      var st = document.createElement("style");
      st.id = STYLE_ID;
      st.textContent = css;
      document.head.appendChild(st);
    }

    /* ======================== TOAST ======================== */

    // Mensagem pendente: sobrevive ao redesenho da gaveta até ser exibida.
    var pendingMsg = null;

    // .halo-sidebar-wrapper vem do Liquid (halo-cart-sidebar.liquid) e está SEMPRE
    // no DOM, gaveta aberta ou fechada. O conteúdo (.previewCart-wrapper) é
    // reescrito pelo tema a cada redesenho — encaixando o toast no wrapper, e não
    // dentro do conteúdo, ele sobrevive a isso.
    function mountToast() {
      if (!pendingMsg) return;
      var drawer =
        document.querySelector("#halo-cart-sidebar .halo-sidebar-wrapper") ||
        document.querySelector("#halo-cart-sidebar");
      if (!drawer) return; // gaveta ainda não montada: espera
      if (document.getElementById(TOAST_ID)) return;

      var el = document.createElement("div");
      el.id = TOAST_ID;
      el.setAttribute("role", "status");
      el.innerHTML =
        '<span class="gd-kit-ico">ℹ️</span>' +
        '<span class="gd-kit-txt">' +
        pendingMsg +
        "</span>" +
        '<button class="gd-kit-x" type="button" aria-label="Fechar aviso">✕</button>';
      drawer.insertBefore(el, drawer.firstChild);

      el.querySelector(".gd-kit-x").addEventListener("click", function () {
        pendingMsg = null;
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    }

    function notify(msg) {
      pendingMsg = msg;
      mountToast();
    }

    /* ======================== CART HELPERS ======================== */

    function getCart() {
      return fetch(ROOT + "cart.js", { credentials: "same-origin" }).then(
        function (r) {
          return r.json();
        }
      );
    }

    function isKitLine(item) {
      return (
        String(item.variant_id) === String(KIT_VARIANT_ID) ||
        String(item.product_id) === KIT_PRODUCT_ID
      );
    }

    function cartHasKit(cart) {
      return (cart.items || []).some(isKitLine);
    }

    // Remove a linha do Kit (quantity 0) — /cart/change.js aceita id da LINHA.
    function removeKitLines(cart) {
      var lines = [];
      (cart.items || []).forEach(function (it, i) {
        if (isKitLine(it)) lines.push(i + 1); // change.js é 1-indexed
      });
      if (!lines.length) return Promise.resolve(false);

      // Remove de trás pra frente: tirar a linha 1 renumera as seguintes.
      var chain = Promise.resolve();
      lines
        .sort(function (a, b) {
          return b - a;
        })
        .forEach(function (line) {
          chain = chain.then(function () {
            return fetch(ROOT + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              credentials: "same-origin",
              body: JSON.stringify({ line: line, quantity: 0 }),
            });
          });
        });
      return chain.then(function () {
        return true;
      });
    }

    /* ======================== CUPOM: REMOÇÃO CIRÚRGICA ========================
       No tema antigo era um cupom por carrinho, então limpar tudo
       (/cart/update.js discount:'') era equivalente a limpar o do Kit.

       O tema novo aceita MÚLTIPLOS cupons: o <cart-discount-component>
       (cart-tools.js) manda todos de uma vez, separados por vírgula, e o
       /cart/update.js SUBSTITUI a lista inteira. Limpar tudo aqui derrubaria
       cupons legítimos que a cliente tenha aplicado junto. Então lemos os cupons
       de agora, tiramos SÓ os do Kit e regravamos o resto — mesma ideia da
       remoção cirúrgica de linha que a regra já usa pros produtos. */

    function setDiscounts(codes) {
      return fetch(ROOT + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ discount: codes.join(",") }),
      }).catch(function () {
        /* silencioso */
      });
    }

    // Espelha o localStorage do <cart-discount-component> (chave 'appliedDiscounts').
    // Ele se auto-corrige no próximo syncWithCartDiscounts(), mas até lá a etiqueta
    // do cupom continuaria na tela marcada como "Não aplicável" — ruído sem motivo.
    function pruneStoredDiscounts() {
      try {
        var raw = localStorage.getItem("appliedDiscounts");
        if (!raw) return;
        var list = JSON.parse(raw);
        if (!Array.isArray(list)) return;
        var next = list.filter(function (c) {
          return !KIT_COUPON_RE.test(String(c));
        });
        if (next.length !== list.length) {
          localStorage.setItem("appliedDiscounts", JSON.stringify(next));
        }
      } catch (e) {}
    }

    function clearKitCoupon() {
      return getCart()
        .then(function (cart) {
          // Guarda TODOS os cupons que não são do Kit, inclusive os que estão
          // applicable:false agora. Um cupom pode ficar temporariamente
          // inaplicável (a cliente aplicou e depois tirou itens, caindo abaixo do
          // mínimo) e volta a valer quando o carrinho crescer — filtrar por
          // applicable aqui apagaria a intenção dela sem motivo.
          // O do Kit, ao contrário, sai mesmo applicable:false: num carrinho sem
          // o Kit ele SEMPRE vem false, e é exatamente esse o caso que a gente
          // está limpando.
          var keep = (cart.discount_codes || [])
            .filter(function (d) {
              return d && d.code && !KIT_COUPON_RE.test(String(d.code));
            })
            .map(function (d) {
              return d.code;
            });
          return setDiscounts(keep);
        })
        .catch(function () {
          // Não deu pra ler o carrinho: o cupom do Kit é o furo de R$247,27, então
          // preferimos limpar tudo a deixá-lo aplicado. Um cupom legítimo perdido a
          // cliente reaplica; o do Kit não pode ficar.
          return setDiscounts([]);
        })
        .then(function () {
          pruneStoredDiscounts();
        });
    }

    // Redesenha o carrinho. window.updateCart() (theme.js:240) recarrega a gaveta e
    // ABRE ela — aqui isso é o comportamento certo: a remoção é reação direta a um
    // clique da cliente e o toast precisa ser visto na hora.
    function refreshCart() {
      try {
        if (typeof window.updateCart === "function") window.updateCart();
      } catch (e) {}
    }

    /* ======================== A REGRA ======================== */

    var enforcing = false;

    // Roda depois de QUALQUER mutação de carrinho detectada.
    // addedVariantId: o que acabou de entrar (quando dá pra saber).
    function enforce(addedVariantId) {
      if (enforcing) return Promise.resolve();
      enforcing = true;

      return getCart()
        .then(function (cart) {
          var items = cart.items || [];
          if (!cartHasKit(cart)) {
            enforcing = false;
            return;
          }

          // Itens que NÃO são o Kit e NÃO são o brinde do sistema.
          var intruders = items.filter(function (it) {
            return (
              !isKitLine(it) &&
              String(it.variant_id) !== String(SERUM_VARIANT_ID)
            );
          });

          if (!intruders.length) {
            enforcing = false;
            return;
          }

          // Guarda de sanidade: nunca esvaziar o carrinho. Se o Kit é a única
          // linha "removível" e não há mais nada, não faz nada.
          if (items.length <= 1) {
            enforcing = false;
            return;
          }

          return removeKitLines(cart)
            .then(function (removed) {
              if (!removed) return;
              return clearKitCoupon().then(function () {
                notify(MSG_REMOVED);
                refreshCart();
              });
            })
            .then(function () {
              enforcing = false;
            })
            .catch(function (e) {
              enforcing = false;
              console.warn("[KIT-GUARD] falha ao aplicar a regra:", e);
            });
        })
        .catch(function (e) {
          enforcing = false;
          console.warn("[KIT-GUARD] falha ao ler o carrinho:", e);
        });
    }

    /* ======================== INTERCEPTAÇÃO ======================== */

    // URLs que MUTAM o carrinho e devem disparar a regra.
    function isCartMutation(url) {
      if (!url) return false;
      var u = String(url);
      return (
        /\/cart\/add(\.js)?(\?|$)/.test(u) ||
        /\/cart\/change(\.js)?(\?|$)/.test(u) ||
        /\/cart\/update(\.js)?(\?|$)/.test(u)
      );
    }

    // Só /cart/add dispara a REGRA DE PRODUTO: change/update são o próprio guard
    // agindo (ou a cliente mexendo em quantidade), e re-disparar causaria laço.
    function isAdd(url) {
      return url && /\/cart\/add(\.js)?(\?|$)/.test(String(url));
    }

    // change/update disparam só a CHECAGEM DE CUPOM (enforceCoupon), que não tem
    // o problema de laço — ver o bloco CUPOM ÓRFÃO. É por aqui que passam a
    // remoção da linha do Kit à mão (/cart/change.js) e o cupom aplicado pelo
    // <cart-discount-component> (/cart/update.js).
    function isCouponRelevant(url) {
      return !isAdd(url) && isCartMutation(url);
    }

    var origFetch = window.fetch;
    if (typeof origFetch === "function") {
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : input && input.url;
        var p = origFetch.apply(this, arguments);
        if (isAdd(url)) {
          // Observa o resultado SEM consumir o body (só lê res.ok) e devolve a
          // Promise original intacta — o chamador (tema/app) segue lendo o
          // response normalmente. Um .then() aqui não clona nem trava o body.
          p.then(
            function (res) {
              if (res && res.ok)
                setTimeout(function () {
                  enforce();
                }, 60);
            },
            function () {
              /* erro de rede: nada a fazer */
            }
          );
        } else if (isCouponRelevant(url)) {
          p.then(
            function (res) {
              if (res && res.ok)
                setTimeout(function () {
                  enforceCoupon();
                }, 60);
            },
            function () {
              /* erro de rede: nada a fazer */
            }
          );
        }
        return p;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__gdKitUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (isAdd(xhr.__gdKitUrl)) {
        xhr.addEventListener("load", function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            setTimeout(function () {
              enforce();
            }, 60);
          }
        });
      } else if (isCouponRelevant(xhr.__gdKitUrl)) {
        xhr.addEventListener("load", function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            setTimeout(function () {
              enforceCoupon();
            }, 60);
          }
        });
      }
      return origSend.apply(this, arguments);
    };

    /* ======================== CUPOM DIGITADO À MÃO ========================
       Se a cliente colar KITEXPERIMENTACAO* sem o Kit no carrinho, recusa.

       No tema antigo isso era um clique no botão de aplicar do Kaching. Aqui quem
       aplica é o <cart-discount-component> (cart-tools.js), e ele avisa: depois de
       aplicar, remover ou limpar cupom ele dispara 'discount:update' no document
       (events.js). Escutamos esse evento em vez de vigiar botão — assim cobrimos
       os três caminhos do componente de uma vez, e também qualquer outro código que
       venha a disparar o mesmo evento.

       POR QUE REAGIR DEPOIS E NÃO BLOQUEAR ANTES: decidir exige ler /cart.js, que é
       assíncrono, e preventDefault() precisa ser síncrono. Bloquear no submit
       obrigaria a manter um palpite em cache do estado do carrinho — que erra
       justamente no caso que importa (o carrinho acabou de mudar). Deixar aplicar e
       tirar em seguida é o que o guard do tema antigo já fazia, e o cupom só vale de
       verdade no checkout: nada é cobrado errado nessa janela de ~1s.

       O componente guarda a lista de cupons no localStorage e a re-sincroniza com
       /cart.js — por isso o clearKitCoupon() também limpa a chave dele. */

    /* CUPOM ÓRFÃO — o mesmo furo por outro caminho (21/Ago/2026)
       Cenário que nem este guard nem o do tema antigo cobriam: a cliente chega
       pela LP com Kit + cupom no carrinho (o permalink aplica os dois de uma vez)
       e remove a linha do Kit NA MÃO, pelo carrinho do tema. Sobra o cupom
       sozinho, e no checkout ele abate o que ficou — mesmo prejuízo do
       −R$247,27, só que chegando por /cart/change em vez de /cart/add.

       A regra de PRODUTO (enforce) não cobre isso de propósito: ela só reage a
       /cart/add, porque reagir a change/update entraria em laço com a própria
       remoção que ela faz. Aqui é o inverso e o laço se fecha sozinho: a ação é
       TIRAR o cupom, então na segunda passada não há mais cupom do Kit pra achar
       e a função vira no-op. O custo de um eventual disparo extra é uma leitura
       de /cart.js.

       Mesma decisão que o cupom digitado à mão: agir DEPOIS. */

    var couponEnforcing = false;

    function enforceCoupon() {
      if (couponEnforcing) return Promise.resolve();
      couponEnforcing = true;

      return getCart()
        .then(function (cart) {
          if (cartHasKit(cart)) return; // com o Kit: cupom é legítimo
          var hasKitCoupon = (cart.discount_codes || []).some(function (d) {
            return d && KIT_COUPON_RE.test(String(d.code));
          });
          if (!hasKitCoupon) return; // nada do Kit aplicado: não é com a gente
          return clearKitCoupon().then(function () {
            notify(MSG_COUPON);
            refreshCart();
          });
        })
        .then(function () {
          couponEnforcing = false;
        })
        .catch(function (e) {
          couponEnforcing = false;
          console.warn("[KIT-GUARD] falha ao limpar o cupom:", e);
        });
    }

    function watchCoupon() {
      document.addEventListener("discount:update", function () {
        enforceCoupon();
      });
    }

    /* ======================== OBSERVER (re-injeta o toast) ======================== */

    function observe() {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          mountToast();
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
      window.__GD_KIT_MO = mo;
    }

    /* ======================== BOOT ======================== */

    injectCSS();
    watchCoupon();
    observe();

    // Carrinho pode já estar "sujo" de uma sessão anterior (cliente fechou o
    // browser com Kit + outro produto, ou com o cupom órfão). Uma verificação no
    // load resolve os dois.
    function enforceAll() {
      enforce();
      enforceCoupon();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", enforceAll);
    } else {
      enforceAll();
    }

    // Volta do bfcache (botão voltar do browser) — DOMContentLoaded não dispara.
    // Mesmo tratamento que os guards de mini pote e garrafa já tinham; aqui pega
    // quem volta do checkout tendo mexido no carrinho.
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) enforceAll();
    });
  } catch (e) {
    console.warn("[KIT-GUARD] fatal error:", e);
  }
})();
